import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchDataRoomSetupDocumentsThunk } from "@dataRoomSetup/store/fetchDataRoomSetupDocumentThunk";
import { DocumentResponse } from "@documents/models/api.models";

interface InitialDocumentsState {
  setupDocument: DocumentResponse[];
  loading: boolean;
  error: string | null;
}

const initialState: InitialDocumentsState = {
  setupDocument: [],
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "initialDocuments",
  initialState,
  reducers: {
    updateDocumentsFolderPath(state, action: PayloadAction<{ documentIds: string[]; newFolderPath: string }>) {
      const { documentIds, newFolderPath } = action.payload;

      state.setupDocument = state.setupDocument.map((doc) =>
        documentIds.includes(doc.documentId + "") ? { ...doc, folderPath: newFolderPath } : doc
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataRoomSetupDocumentsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDataRoomSetupDocumentsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.setupDocument = action.payload;
      })
      .addCase(fetchDataRoomSetupDocumentsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch folders";
      });
  },
});

export const { updateDocumentsFolderPath } = slice.actions;

export default slice.reducer;
